import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const ENDOFMONTH = () => {
  return (
    <CardSection id="ENDOFMONTH" title="ENDOFMONTH">
      <Paragraph>
        새 DateTime 열에 해당 월의 마지막 날에 대한 날짜/시간을 반환합니다. 이는
        Excel의 EOMONTH 함수와 동일한 값을 제공합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>ENDOFMONTH(DATETIME)</Paragraph>
        <Ul>
          <Li>
            <b>DATETIME</b>은 추출하려는 날짜입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>ENDOFMONTH(`Date`)</Paragraph>
        <Img src="computeEndOfMonth" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          <b>DATETIME</b>은 날짜/시간 객체, 날짜/시간 객체를 포함하는 열 또는
          날짜/시간 객체를 반환하는 함수여야 합니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
